import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Table } from "react-bootstrap";
import { S3_URL, CODE_SYSTEM } from "../services/Constants";
import {
  addCodeSetTable,
  addCodeSetTableValues,
  addNewCodeSetValueinRefTable,
  fetchCodeSetListTable,
  fetchCodeSetTableWithPagination,
  getTableId,
  removeCodeSetTable,
  removeTableNamefromCodeSetList,
  updateCodeSetTableValues,
} from "../services/referenceTable-service";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import {
  CSTAVSB,
  CSTRB,
  CSUMAVB,
  CSUMUB,
  CSUMDB,
} from "../util/component-codes";
import Pagination from "@mui/material/Pagination";
import { MenuItem, Select } from "@mui/material";
import Cookies from "js-cookie";
import Alert from "react-bootstrap/Alert";

const initialRows = [
  {
    reference_code: "",
    reference_Code_description: "",
    reference_Code_system: "",
  },
];

const CodeSets = () => {
  const [errorMessage, setErrorMessage] = useState();
  const [dropdownValues, setDropdownValues] = useState(null);
  const [valueSet, setValueSet] = useState("");
  const [showValueSetModal, setShowValueSetModal] = useState(false);
  const [modalAddorUpdate, setModalAddOrUpdate] = useState("Add");
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [rows, setRows] = useState(JSON.parse(JSON.stringify(initialRows)));
  const [tableId, setTableId] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [reload, setReload] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(
    Cookies.get("itemsPerPage") ? Cookies.get("itemsPerPage") : 15
  );
  const [user] = useContext(UserContext);

  const addUpdateValueSet = () => {
    let copy = [...rows];
    let newArray = JSON.parse(JSON.stringify(initialRows[0]));
    copy.push(newArray);
    setRows(copy);
  };

  const handleValueSetChange = async (value) => {
    setValueSet(value);
    let response = await fetchCodeSetTableWithPagination(
      currentPage - 1,
      rowsPerPage,
      value
    );
    if (response.ok) {
      let data = await response.json();
      setRows(data?.genericList ? data.genericList : null);
      // setTableId(data.referenceTableId ? data.referenceTableId : 0);
      setTotalPages(data?.totalPages ? data?.totalPages : 1);
    }
  };

  const getTableIdFromTableName = async (value) => {
    let response = await getTableId(value);
    if (response.ok) {
      let data = await response.json();
      setTableId(data ? data : 0);
    }
  };

  const handleAddNewValueSet = () => {
    setErrorMessage();

    setValueSet("");
    setModalAddOrUpdate("Add");
    setRows(JSON.parse(JSON.stringify(initialRows)));
    setShowValueSetModal(true);
  };

  const handleUpdateValueSet = () => {
    setErrorMessage();

    setModalAddOrUpdate("Update");
    setShowValueSetModal(true);
  };

  const addOrUpdateValueSet = async () => {
    setErrorMessage();

    let form = {
      referenceTableName: valueSet,
    };
    const withReferenceTableValueId = [];
    const withoutReferenceTableValueId = [];

    rows.forEach((obj) => {
      if (obj.hasOwnProperty("referenceTableValueId")) {
        withReferenceTableValueId.push(obj);
      } else {
        withoutReferenceTableValueId.push(obj);
      }
    });

    if (modalAddorUpdate === "Update") {
      form.referenceTableId = tableId;
      if (withReferenceTableValueId.length > 0) {
        form.refTableValues = withReferenceTableValueId;
        updateCodeSetTableValues(tableId, form);
      }

      if (withoutReferenceTableValueId.length > 0) {
        let response = await addCodeSetTableValues(
          tableId,
          withoutReferenceTableValueId
        );

        if (!response.ok) {
          let error = await response.json();
          setErrorMessage(error?.message);
        }
        // if (response.ok) {
        //   let error = await response.json();
        //   setAlertMessage(error?.description);

        setReload(true);
      }
    } else {
      let putForm = {
        reference_code: valueSet,
        reference_Code_description: valueSet,
        reference_Code_system: null,
      };
      addNewCodeSetValueinRefTable(putForm);
      form.refTableValues = rows;
      addCodeSetTable(form);

      //Add in dropdown
      let copyDropdown = [...dropdownValues];
      copyDropdown.push(valueSet);
      setDropdownValues(copyDropdown);
    }
    setShowValueSetModal(false);
  };

  const removeAllValueSet = () => {
    setErrorMessage();

    setValueSet("");
    setRows(JSON.parse(JSON.stringify(initialRows)));
    removeTableNamefromCodeSetList(valueSet);
    removeCodeSetTable(tableId);
    setShowRemoveWarningModal(false);

    //Remove from dropdown
    let copyDropdown = [...dropdownValues];
    copyDropdown = copyDropdown.filter((e) => e !== valueSet);
    setDropdownValues(copyDropdown);
  };

  const getCodeSetListTableData = async () => {
    let response = await fetchCodeSetListTable();
    let data = await response.json();
    let array = [];
    data.refTableValues.forEach(function (item, index) {
      array.push(item.reference_code);
    });
    setDropdownValues(array);
  };

  const updateRows = (index, key, value) => {
    let copyRows = [...rows];
    let X = copyRows[index];
    X[key] = value;
    setRows(copyRows);
  };

  const handlePageChange = (event, value) => {
    setErrorMessage();

    setCurrentPage(value);
  };

  const handleDropdownChange = (event, value) => {
    setErrorMessage();

    setCurrentPage(1);
    handleValueSetChange(event.target.value);
    getTableIdFromTableName(event.target.value);
  };
  const handleRemove = (event) => {
    setErrorMessage();
    setShowRemoveWarningModal(true);
  };

  const handleItemsPerPage = (event) => {
    if (event.target.value === null) {
      setRowsPerPage(5);
    } else {
      setRowsPerPage(event.target.value);
      Cookies.set("itemsPerPage", JSON.stringify(event.target.value), {
        expires: 7,
      });
      setCurrentPage(1);
    }
  };

  useEffect(() => {
    valueSet && handleValueSetChange(valueSet);
  }, [currentPage, rowsPerPage]);

  useEffect(() => {
    getCodeSetListTableData();
  }, []);

  useEffect(() => {
    if (reload === true) {
      handleValueSetChange(valueSet);
      setReload(false);
    }
  }, [reload]);

  return (
    <Container fluid className="loincContainer">
      <Row>
        <Col xl={8}>
          <Row
            className="tableTitle generalFont"
            style={{ paddingLeft: "5px" }}
          >
            Code Sets
          </Row>
          <Row
            className="tableSubtitle generalFont"
            style={{ paddingLeft: "10px" }}
          >
            Below are the value sets and their associated codes
          </Row>
        </Col>

        <Box style={{ maxWidth: "95%" }}>
          {errorMessage && (
            <Alert
              variant={errorMessage && "danger"}
              onClose={() => {
                setErrorMessage();
              }}
              dismissible
            >
              {errorMessage}
            </Alert>
          )}
          <Paper>
            <div className="tableToolbar flexCenter">
              <div className="flexCenter">
                <Form.Select
                  name="sourceField"
                  className="modalInput generalFont"
                  aria-label="Field"
                  required
                  style={{ marginLeft: "10px" }}
                  value={valueSet}
                  onChange={handleDropdownChange}
                >
                  <option hidden value="">
                    Choose Value Set
                  </option>
                  {dropdownValues &&
                    dropdownValues.map((value, index) => (
                      <option key={index} value={value}>
                        {value}
                      </option>
                    ))}
                </Form.Select>
                {valueSet !== "" && (
                  <Button
                    className="updateButtonStyle generalFont flexCenter"
                    onClick={() => handleUpdateValueSet()}
                  >
                    <img
                      src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
                      className="buttonIcon"
                      alt=""
                    ></img>
                    Update
                  </Button>
                )}
                {valueSet !== "" && componentIsVisible(CSTRB, user) && (
                  <Button
                    className="removeButtonStyle generalFont flexCenter"
                    onClick={() => handleRemove()}
                  >
                    <img
                      src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
                      className="buttonIcon"
                      alt=""
                    ></img>
                    Remove
                  </Button>
                )}
              </div>
              {componentIsVisible(CSTAVSB, user) && (
                <div className="flexCenter">
                  <Button
                    className="addNewBtn flexCenter generalFont"
                    onClick={() => handleAddNewValueSet()}
                  >
                    <img
                      src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                      alt=""
                      style={{ marginRight: "10px" }}
                    ></img>
                    Add New Value Set
                  </Button>
                </div>
              )}
            </div>
          </Paper>
        </Box>
      </Row>
      {valueSet && (
        <div className="tableContainer" style={{ maxWidth: "95%" }}>
          <Table className="tableN backgroundBlur" bordered hover size="sm">
            <thead>
              <tr>
                <th style={{ minWidth: "250px" }}>Standard Value Code</th>
                <th style={{ minWidth: "250px" }}>Description</th>
                <th style={{ minWidth: "250px" }}>Code System</th>
              </tr>
            </thead>
            <tbody>
              {rows &&
                rows.map((row, index) => (
                  <tr key={index}>
                    <td>{row.reference_code}</td>
                    <td>{row.reference_Code_description}</td>
                    <td>{row.reference_Code_system}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <>
            <br />
            <div className="pagContainer flexCenter">
              <div className="flexCenter">
                <label style={{ marginRight: "8px" }}>Show</label>
                <Select
                  sx={{ minWidth: 80, maxHeight: 40, background: "white" }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={rowsPerPage}
                  autoWidth
                  onChange={handleItemsPerPage}
                >
                  <MenuItem value={5}>5 </MenuItem>
                  <MenuItem value={15}>15 </MenuItem>
                  <MenuItem value={25}>25 </MenuItem>
                  <MenuItem value={50}>50 </MenuItem>
                  <MenuItem value={100}>100 </MenuItem>
                </Select>
                <label style={{ marginLeft: "8px" }}>results per page</label>
              </div>
              <div className="flexCenter">
                <Pagination
                  variant="outlined"
                  shape="rounded"
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePageChange}
                  defaultPage={1}
                  color="primary"
                  size="medium"
                ></Pagination>
              </div>
            </div>
          </>
        </div>
      )}
      <Modal
        show={showValueSetModal}
        onHide={() => {
          handleValueSetChange(valueSet);
          setShowValueSetModal(false);
        }}
        size="lg"
        centered
      >
        <Form noValidate>
          <Modal.Header className="modalHeaderContainer" closeButton>
            <Modal.Title className="modalHeader generalFont">
              {modalAddorUpdate} Value Set
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modalBodyContainer">
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="sendingFacilityName">
                  <Form.Label className="modalLabel generalFont">
                    Value Set Name
                  </Form.Label>
                  <Form.Control
                    className="modalInput generalFont"
                    type="text"
                    required
                    placeholder="Enter a new Value Set"
                    disabled={modalAddorUpdate === "Update"}
                    value={valueSet}
                    onChange={(e) => setValueSet(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col></Col>
              <Col></Col>
            </Row>
            <Row>
              <Col>
                <Form.Group className="mb-3" controlId="sendingFacilityName">
                  <Form.Label className="modalLabel generalFont">
                    Value Code
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="sendingFacilityCode">
                  <Form.Label className="modalLabel generalFont">
                    Description
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3" controlId="sendingFacilityCode">
                  <Form.Label className="modalLabel generalFont">
                    Code System
                  </Form.Label>
                </Form.Group>
              </Col>
              <Col xs={2}>
                <Form.Group className="mb-3" controlId="sendingFacilityCode">
                  <Form.Label className="modalLabel generalFont">
                    Status
                  </Form.Label>
                </Form.Group>
              </Col>
            </Row>
            {rows &&
              rows.map((row, index) => {
                return (
                  <>
                    <Row>
                      <Col>
                        <Form.Control
                          className="modalInput generalFont"
                          type="text"
                          required
                          value={row.reference_code}
                          onChange={(e) =>
                            updateRows(index, "reference_code", e.target.value)
                          }
                        />
                      </Col>
                      <Col>
                        {" "}
                        <Form.Control
                          className="modalInput generalFont"
                          type="text"
                          required
                          value={row.reference_Code_description}
                          onChange={(e) =>
                            updateRows(
                              index,
                              "reference_Code_description",
                              e.target.value
                            )
                          }
                        />
                      </Col>
                      <Col>
                        {" "}
                        <Form.Select
                          name="sourceField"
                          className="modalInput generalFont"
                          aria-label="Field"
                          required
                          value={row.reference_Code_system}
                          onChange={(e) =>
                            updateRows(
                              index,
                              "reference_Code_system",
                              e.target.value
                            )
                          }
                        >
                          <option hidden value="">
                            Choose Item
                          </option>
                          {CODE_SYSTEM.map((value, index) => (
                            <option key={index} value={value}>
                              {value}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                      <Col xs={2}>
                        {componentIsVisible(CSUMDB, user) && (
                          <Button
                            onClick={(event) =>
                              updateRows(index, "isActive", !row?.isActive)
                            }
                            className={`${
                              row?.isActive
                                ? "activeColStyle"
                                : "inactiveColStyle"
                            }`}
                          >
                            {row?.isActive ? "Active" : "Inactive"}
                          </Button>
                        )}
                      </Col>
                    </Row>
                    <br />
                  </>
                );
              })}
            {componentIsVisible(CSUMAVB, user) && (
              <Button
                className="tableAddFieldBtn flexCenter generalFont"
                onClick={() => addUpdateValueSet()}
              >
                Add New Value
              </Button>
            )}
          </Modal.Body>
          <Modal.Footer className="modalFooterContainer">
            {componentIsVisible(CSUMUB, user) && (
              <Button
                disabled={valueSet.length === 0}
                className="modalAddUpdateStyle generalFont flexCenter"
                onClick={() => addOrUpdateValueSet()}
              >
                <img
                  src={`${validateAndSanitizeUrl(S3_URL)}plus-icon.png`}
                  alt=""
                  style={{ marginRight: "10px" }}
                ></img>
                {modalAddorUpdate}
              </Button>
            )}
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal
        show={showRemoveWarningModal}
        onHide={() => setShowRemoveWarningModal(false)}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Code Set for {valueSet}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove all the Code Set for {valueSet}{" "}
              Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={() => setShowRemoveWarningModal(false)}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => removeAllValueSet(valueSet)}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default CodeSets;
